import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export const CustomIconPayment = ({ icon }: any) => {
  return (
    <FontAwesomeIcon className="payment-icon" icon={icon} color="#00f2c3" />
  );
};
